import { Permission } from '@traton/devportal-rbac-common-lib';

export const agenticMarketplaceReadPermission: Permission = {
  name: 'agentic-marketplace.read',
  description: 'Allows access to the Agentic Marketplace',
};
